module.exports = "### ToolbarSeparator Properties\n\nA vertical bar used to separate groups of components. \nIt is used to easily organize components within a `Toolbar`.\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/pages/components/Toolbar/ToolbarSeparator.md
 ** module id = 1094
 ** module chunks = 0
 **/